import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Drawer, Button } from '@material-ui/core/'
import Box from 'components/UI/Box'
import PropTypes from 'prop-types'
import { Theme } from '../../utils/Theme'
const theme = Theme()

const useStyles = makeStyles({
  list: {
    // width: 280,
  },
  fullList: {
    width: 'auto',
  },
  ...theme,
})

export default function TemporaryDrawer(props) {
  const classes = useStyles()
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  const { anchor, children, icon, toggleOnClick, ToggleButton, toggleOnKeyDown, width } = props
  return (
    <div>
      <React.Fragment key={anchor}>
        <Box onClick={toggleDrawer(anchor, true)}>
          {icon && <Button>{icon}</Button>}
          {ToggleButton && ToggleButton}
        </Box>
        <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
          {/*{list(anchor)}*/}
          <Box height={'100%'} >
            <div
              className={`${clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
              })}`}
              style={{ width: width }}
              role="presentation"
              onClick={toggleDrawer(anchor, !toggleOnClick)}
              onKeyDown={toggleDrawer(anchor, !toggleOnKeyDown)}
            >
              {children}
            </div>
          </Box>
        </Drawer>
      </React.Fragment>
    </div>
  )
}

TemporaryDrawer.propTypes = {
  anchor: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  toggleOnClick: PropTypes.bool,
  ToggleButton: PropTypes.any,
  toggleOnKeyDown: PropTypes.bool,
}
